import { Radio } from 'ui/radio';
import { LeftTooltip } from 'ui/tooltip';
import { displayDate, getFromNow, DATE_FORMAT_FULL_WITH_TIME } from 'utils/date';
import { TableCell, RadioCell, TABLE_CELL_VARIANTS } from '../TableSelect';

const COLUMN_DEFAULTS = { align: 'flex-start', sortable: true, searchable: true };

export const UPDATE_CONTACT_COLUMNS = [
  {
    ...COLUMN_DEFAULTS,
    name: '',
    value: '__typename',
    sortable: false,
    searchable: false,
    RowCell: ({ isSelected }) => (
      <RadioCell>
        <Radio isChecked={isSelected} />
      </RadioCell>
    ),
  },
  {
    ...COLUMN_DEFAULTS,
    name: 'List',
    value: 'name',
    RowCell: ({ row }) => <TableCell variant={TABLE_CELL_VARIANTS.MAIN}>{row.name}</TableCell>,
  },
  {
    ...COLUMN_DEFAULTS,
    name: 'ID',
    value: 'id',
    RowCell: ({ row }) => <TableCell>{row.id}</TableCell>,
  },
  {
    ...COLUMN_DEFAULTS,
    name: 'Updated',
    value: 'updatedAt',
    searchable: false,
    RowCell: ({ row }) => (
      <TableCell>
        {row.updatedAt && (
          <LeftTooltip tooltipContent={displayDate(row.updatedAt, DATE_FORMAT_FULL_WITH_TIME)}>
            {getFromNow(row.updatedAt)}
          </LeftTooltip>
        )}
      </TableCell>
    ),
  },
];
